 export default {
    state:{
        //当前导航
        activeIndex:  JSON.parse(window.sessionStorage.getItem('activeIndex')),
    },
    mutations:{
        //当前导航
        get_active_index(state, data) {
            state.activeIndex = data
               window.sessionStorage.setItem('activeIndex', JSON.stringify(data))
        },
    },
    actions:{},
    getters:{}
}